import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import index from '@/components/index'
import home from '@/components/home'

//设置
import set from '@/components/set/set'
import administratorList from '@/components/set/administratorList'
import buyerList from '@/components/set/buyerList'
import subsidiaryList from '@/components/set/subsidiaryList'
import subsidiariesPrincipalsList from '@/components/set/subsidiariesPrincipalsList'
import supplierList from '@/components/set/supplierList'
import receiverList from '@/components/set/receiverList'
import changepassword from '@/components/set/changepassword'

//管理员
import addUser from '@/components/user/addUser'
import editUser from '@/components/user/editUser'

//物料管理
import goodsCatalog from '@/components/goods/goodsCatalog'
import addGoodsCatalog from '@/components/goods/addGoodsCatalog'
import editGoodsCatalog from '@/components/goods/editGoodsCatalog'
import goodsList from '@/components/goods/goodsList'
import addGoods from '@/components/goods/addGoods'
import editGoods from '@/components/goods/editGoods'

//订单管理
import editDemand from '@/components/order/editDemand'
import demandlist from '@/components/order/demandlist'
import orderslist from '@/components/order/orderslist'
import editOrder from '@/components/order/editOrder'
import polist from '@/components/order/polist'

//统计
import statistics from '@/components/statistics'
import servicelist from '@/components/servicelist'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '登录页',
      component: login
    },
    {
      name: '登录页',
      path: '/login',
      component: login
    },
    {
      path: '/home',
      name: '首页',
      component: home,
      children: [
        {name: '首页',path: 'index', component: index},

        //设置
        {name: '基础设置',path: 'set', component: set},
        {name: '管理员',path: 'administratorList', component: administratorList},
        {name: '修改密码',path: 'changepassword', component: changepassword},
        {name: '采购员设置',path: 'buyerList', component: buyerList},
        {name: '子公司设置',path: 'subsidiaryList', component: subsidiaryList},
        {name: '子公司负责人设置',path: 'subsidiariesPrincipalsList', component: subsidiariesPrincipalsList},
        {name: '供应商设置',path: 'supplierList', component: supplierList},
        {name: '收货员设置',path: 'receiverList', component: receiverList},

        //管理员
        {name: '添加管理员',path: 'addUser', component: addUser},
        {name: '编辑管理员',path: 'editUser', component: editUser},

        //物料管理
        {name: '物料目录',path: 'goodsCatalog', component: goodsCatalog},
        {name: '新建物料目录',path: 'addGoodsCatalog', component: addGoodsCatalog},
        {name: '编辑物料目录',path: 'editGoodsCatalog', component: editGoodsCatalog},
        {name: '物料列表',path: 'goodsList', component: goodsList},
        {name: '新建物料',path: 'addGoods', component: addGoods},
        {name: '编辑物料',path: 'editGoods', component: editGoods},

        //订单管理
        {name: '编辑需求',path: 'editDemand', component: editDemand},
        {name: '需求管理',path: 'demandlist', component: demandlist},
        {name: '订单管理',path: 'orderslist', component: orderslist},
        {name: '编辑订单',path: 'editOrder', component: editOrder},
        {name: 'po单管理',path: 'polist', component: polist},

        //统计
        {name: '统计',path: 'statistics', component: statistics},
        {name: '售后',path: 'servicelist', component: servicelist},
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js